module.exports = __webpack_public_path__ + "static/img/virtualReality6.00180ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/virtualReality6.png
// module id = 6Ve5
// module chunks = 13